<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import {http} from '../services/config/config-receituario'

/**
 * agronomo Component
 */
export default {
  components: {
    Layout,
    Loading,
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      isLoading: false,
      dropzoneOptions: {
        url: `${http.defaults.baseURL}/empresas/upload`,
        thumbnailWidth: 150,
        timeout: 100000,
        maxFilesize: 1,
        maxFiles: 1,
        headers: { Authorization: this.$store.state.auth.currentUser.token },
        acceptedFiles: '.jpeg,.jpg,.png,.gif,.JPEG,.JPG,.PNG',
        addRemoveLinks: true,
        dictRemoveFile: 'Remover arquivo',
      },
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    vsuccess(file, response) {
      this.isLoading = false
      this.$bvToast.toast('Importado com sucesso!', {
        variant: 'success',
        solid: false,
        noCloseButton: true,
        toaster: 'b-toaster-top-center',
      })
    },
    vsending(file, xhr, formData) {
      this.isLoading = true
    },
    verror(file) {
      this.isLoading = false
      this.$bvToast.toast(
        'Não foi possível importar o arquivo, por favor verifique se o arquivo enviado esta de acordo com o PADRÂO WebReceita.',
        {
          variant: 'danger',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        }
      )
    },
  },
}
</script>
<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="borda"></div>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <vue-dropzone
                  id="dropzone"
                  ref="myVueDropzone"
                  :options="dropzoneOptions"
                  :use-custom-slot="true"
                  @vdropzone-success="vsuccess"
                  @vdropzone-sending="vsending"
                  @vdropzone-error="verror"
                >
                  <div class="text-center">
                    <i class="h1 text-muted uil-cloud-upload"></i>
                    <h3>Selecione o arquivo para importação.</h3>
                    <span class="text-muted font-size-13">
                      (O arquivo deve ter no máximo 3MB e seguir o padrão
                      WebReceita.)
                    </span>
                  </div>
                </vue-dropzone>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </div>
</template>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;
  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .subtitulo {
    margin-bottom: 10px;
  }
  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }
  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;
    &.botaoTopo {
      float: right;
    }
  }
  .filterButton {
    // margin-top: 5px;
    // margin-bottom: 10px;
    background-color: #008e74c7;
    padding: 0 20px;
  }
  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>